import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./SplitView.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import { LinkType } from "../Links/Links";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { Links } from "../Links/Links";
import { PortableText } from "@portabletext/react";
import { customComponentRenderers } from "../Paragraph/Citation";
import { SplitViewForm, SplitViewFormConfiguration } from "./SplitViewForm";
export interface SplitView {
  title: string;
  swapped?: boolean;
  rowSwapped?: boolean;
  darktext?: boolean;
  paragraph?: string;
  richText?: any[];
  links: (LinkType | NavLink)[];
  image: SanityImageObject;
  form?: SplitViewFormConfiguration;
}
export const SplitView: React.FC<SplitView> = t0 => {
  const $ = _c(29);
  const {
    title,
    swapped,
    rowSwapped,
    darktext,
    paragraph,
    richText,
    links,
    image,
    form
  } = t0;
  let classes;
  if ($[0] !== darktext || $[1] !== rowSwapped || $[2] !== swapped) {
    classes = [styles.splitview];
    if (swapped) {
      classes.push(styles.swapped);
    }
    if (rowSwapped) {
      classes.push(styles.rowSwapped);
    }
    if (darktext) {
      classes.push(styles.darktext);
    }
    $[0] = darktext;
    $[1] = rowSwapped;
    $[2] = swapped;
    $[3] = classes;
  } else {
    classes = $[3];
  }
  const t1 = classes.join(" ");
  let t2;
  if ($[4] !== title) {
    t2 = <h4>{title}</h4>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== paragraph || $[7] !== richText) {
    t3 = richText?.length ? <div className={styles.richtext}><PortableText value={richText} components={customComponentRenderers} /></div> : paragraph && <p>{paragraph}</p>;
    $[6] = paragraph;
    $[7] = richText;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== form) {
    t4 = form?.formType && <SplitViewForm form={form} />;
    $[9] = form;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div>{t2}{t3}{t4}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== links) {
    t6 = links?.length > 0 && <Links links={links} />;
    $[15] = links;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className={styles.splitviewtext}>{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== darktext || $[21] !== image) {
    t8 = image && <ResponsiveImage image={image} layout="responsive" sizes={`(min-width: 1920px) 686px, (min-width: 1181px) 36vw, ${darktext ? "100vw" : "90vw"}`} />;
    $[20] = darktext;
    $[21] = image;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t8) {
    t9 = <div className={styles.splitviewimage}>{t8}</div>;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t1 || $[26] !== t7 || $[27] !== t9) {
    t10 = <div className={t1}>{t7}{t9}</div>;
    $[25] = t1;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};